import Head from 'next/head';

import React, { PropsWithChildren } from 'react';

import Footer from './Footer';
import Header from './Header';

// import typography from '../utils/typography';

type Props = PropsWithChildren<{
  title?: string;
}>;

const Layout = React.memo(({ children, title = 'This is the default title' }: Props) => (
  <div className="leading-normal tracking-normal bg-gray-100 min-h-screen">
    <Head>
      <title>{title}</title>
      <meta charSet="utf-8" />
      <meta name="viewport" content="initial-scale=1.0, width=device-width" />
      {/* typography */}
      {/* <TypographyStyle typography={typography} /> */}
    </Head>
    <Header />
    <div className="container w-full px-4 pb-10 mx-auto md:max-w-3xl">{children}</div>
    <Footer />
  </div>
));

export default Layout;
